import { useContext } from 'react';
import MetricsInspectionContext from '../../state/context';

const useReport = () => {
  const {
    state: { widget }
  } = useContext(MetricsInspectionContext);

  return {
    definition: {
      widgets: [widget]
    },
    id: 'MetricsInspection',
    name: 'Metrics Inspection',
    type: 'metrics'
  };
};

export default useReport;
